import { BadgeProps } from '@setel/portal-ui';
import { TRANSACTION_MIX_PAYMENT_METHODS } from 'shared/consts/payment.const';
import { StoreOrderStatus } from 'shared/enums/store-orders.enum';
import { PaymentTransaction } from 'shared/interfaces/payments.interface';

export const getStoreOrderBadgeColor = (
  status?: string
): Extract<BadgeProps['color'], 'lemon' | 'success' | 'error' | 'grey'> => {
  switch (status) {
    case StoreOrderStatus.created:
    case StoreOrderStatus.voidPending:
    case StoreOrderStatus.confirmed:
      return 'lemon';
    case StoreOrderStatus.chargeSuccessful:
    case StoreOrderStatus.pointIssuanceSuccessful:
    case StoreOrderStatus.voidSuccessful:
    case StoreOrderStatus.pointVoidSuccessful:
      return 'success';
    case StoreOrderStatus.voidError:
    case StoreOrderStatus.chargeError:
    case StoreOrderStatus.pointIssuanceError:
    case StoreOrderStatus.error:
    case StoreOrderStatus.pointVoidError:
      return 'error';
    default:
      return 'grey';
  }
};

const mapping = Object.values(TRANSACTION_MIX_PAYMENT_METHODS);

export const getPaymentMethod = (trx: PaymentTransaction) => {
  const matchedMapping = mapping.find(
    (mx) =>
      mx.paymentMethod === trx.paymentMethod &&
      mx.paymentSubmethod === trx.paymentSubmethod
  );
  return matchedMapping ? matchedMapping.text : '';
};
